// src/components/ui/forms/FormCard/FormCardShadcn.jsx
import React from 'react';

// shadcn components
import { Card, CardContent } from '../../card';

import { cn } from '../../../../utils/cn';

const FormCardShadcn = ({
  title,
  icon: Icon,
  children,
  className = '',
  hover = true,
  padding = 'default', // 'sm', 'default', 'lg'
  ...props
}) => {
  // Padding configurations
  const paddingConfig = {
    sm: 'p-4',
    default: 'p-5',
    lg: 'p-6'
  };

  return (
    <Card
      className={cn(
        // Glassmorphism styling
        "bg-slate-800/40 border-slate-700/40 transition-all duration-200",

        // Hover effect
        hover && "hover:border-slate-600/50",

        className
      )}
      {...props}
    >
      <CardContent className={cn("space-y-4", paddingConfig[padding])}>
        {/* Title with optional icon */}
        {(title || Icon) && (
          <div className="flex items-center gap-3">
            {Icon && (
              <div className="p-2 bg-slate-700/50 rounded-lg">
                <Icon className="w-5 h-5 text-slate-300" />
              </div>
            )}
            {title && (
              <h3 className="text-lg font-semibold text-slate-200">{title}</h3>
            )}
          </div>
        )}

        {children}
      </CardContent>
    </Card>
  );
};

export default FormCardShadcn;